import { format } from "date-fns";

import type { PositionFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/position/types/position-form";
import type { PositionFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/position/zod-schemas/position-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty form values with blank date/time for QuestionnaireResponse hydrate. */
export function getEmptyPositionFlowsheetFormValues(): PositionFlowsheetFormValues {
  return {
    positionDate: null,
    positionTime: null,
    clientPosition: null,
    clientInWater: null,
    clientInWaterOther: "",
    positionNotes: "",
    signatureInitials: [],
  };
}

/** Quick-add defaults with the current local date and time. */
export function getDefaultPositionFlowsheetFormValues(): PositionFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyPositionFlowsheetFormValues(),
    positionDate: now,
    positionTime: localToUtcTimeString(localTime),
  };
}

export function normalizePositionFlowsheetFormValues(
  parsed: PositionFlowsheetFormSchemaType,
): PositionFlowsheetFormValues {
  // Keep explicit null date/time so edit hydrate does not fill the current clock.
  const empty = getEmptyPositionFlowsheetFormValues();
  return {
    positionDate: parsed.positionDate !== undefined ? parsed.positionDate : empty.positionDate,
    positionTime: parsed.positionTime !== undefined ? parsed.positionTime : empty.positionTime,
    clientPosition: parsed.clientPosition ?? empty.clientPosition,
    clientInWater: parsed.clientInWater ?? empty.clientInWater,
    clientInWaterOther: parsed.clientInWaterOther ?? empty.clientInWaterOther,
    positionNotes: parsed.positionNotes ?? empty.positionNotes,
    signatureInitials: parsed.signatureInitials ?? empty.signatureInitials,
  };
}
